module.exports = __webpack_public_path__ + "static/media/image-form.c7383fa2.png";